import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Card, Divider } from 'antd'
import PerText from '../../../components/custom_components/Text'
import { ScoreGoalDto, ScoreGridDto } from '../../../types'
import { ScoreGridCategory } from './ScoreGridCategory.enum'
import PerFlexRow from '../../../components/custom_components/FlexRow'

interface TileProp {
  header: string
  scoreGoals: ScoreGoalDto[]
}
const Tile: FC<TileProp> = ({ header, scoreGoals }) => {
  const [t] = useTranslation()

  return (
    <Card bordered={false} className="fullHeight">
      <PerText appearance="tile-heading" mb="xs">
        {header}
      </PerText>
      {scoreGoals.map((item, idx) => (
        <PerFlexRow key={idx} direction="row" justify="space-between" noWrap={true} mb="xxxs">
          <PerText>{t(`appraisalMeeting.evaluation.grid.headline.${item.viewId}`)}</PerText>
          <PerText fontWeight="bold" ml="l">
            {item.resultEvaluation}
          </PerText>
        </PerFlexRow>
      ))}
    </Card>
  )
}

interface Props {
  scoreGrid: ScoreGridDto
}
export const ConclusionEvaluation: FC<Props> = ({ scoreGrid }) => {
  const [t] = useTranslation()

  const tabs = Object.keys(ScoreGridCategory).map((entry) => {
    return { id: entry, title: t(`appraisalMeeting.evaluation.grid.category.${entry}`) }
  })

  const colSpan = 8
  const currentGrid = { ...scoreGrid }

  return (
    <div data-e2e-evaluation-conclusion>
      <PerText appearance="heading" color="primary" mb="s">
        {t('appraisalMeeting.conclusion.evaluation.title')}
      </PerText>

      <PerFlexRow>
        <Col span={colSpan} style={{ marginBottom: '12px' }}>
          <Tile
            key={1}
            header={tabs[0].title}
            scoreGoals={currentGrid.scoreGoals.filter((scoreGoal) => scoreGoal.viewId.toString().startsWith('Customer'))}
          />
        </Col>
        <Col span={colSpan} style={{ marginBottom: '12px' }}>
          <Tile
            key={1}
            header={tabs[1].title}
            scoreGoals={currentGrid.scoreGoals.filter((scoreGoal) => scoreGoal.viewId.toString().startsWith('Speed'))}
          />
        </Col>
        <Col span={colSpan} style={{ marginBottom: '12px' }}>
          <Tile
            key={2}
            header={tabs[2].title}
            scoreGoals={currentGrid.scoreGoals.filter((scoreGoal) => scoreGoal.viewId.toString().startsWith('Teamwork'))}
          />
        </Col>
      </PerFlexRow>

      <PerFlexRow>
        <Col span={colSpan} style={{ marginBottom: '12px' }}>
          <Tile
            key={3}
            header={tabs[3].title}
            scoreGoals={currentGrid.scoreGoals.filter((scoreGoal) => scoreGoal.viewId.toString().startsWith('Excellence'))}
          />
        </Col>
        <Col span={colSpan} style={{ marginBottom: '12px' }}>
          <Tile
            key={4}
            header={tabs[4].title}
            scoreGoals={currentGrid.scoreGoals.filter((scoreGoal) => scoreGoal.viewId.toString().startsWith('Innovation'))}
          />
        </Col>
        <Col span={colSpan} style={{ marginBottom: '12px' }}>
          <Tile
            key={5}
            header={tabs[5].title}
            scoreGoals={currentGrid.scoreGoals.filter((scoreGoal) => scoreGoal.viewId.toString().startsWith('Human'))}
          />
        </Col>
      </PerFlexRow>

      <Divider />
    </div>
  )
}
